<div class="action-item">
    <div class="action-header">
        <div class="action-title">
            <i class="pi" [ngClass]="getActionIcon(action().actionType)"></i>
            <span class="action-type">{{ action().actionType }}</span>
        </div>
        <span class="action-created text-muted">{{ getLastUpdatedTime(action()) }}</span>
    </div>

    <div class="action-timeline">
        <div class="timeline-dots">
            @for (stage of stages(); track $index; let isLast = $last; let isFirst = $first) {
                @if (!isFirst) {
                    <div class="stage-connector" 
                         [class.completed]="getConnectorClass($index) === 'completed'"
                         [class.cancelled]="getConnectorClass($index) === 'cancelled'"></div>
                }
                <div class="stage-dot"
                     [class.completed]="stage.state === 'completed'"
                     [class.active]="stage.state === 'active'"
                     [class.pending]="stage.state === 'pending'"
                     [class.success]="stage.color === 'success'"
                     [class.error]="stage.color === 'error'"
                     [class.warning]="stage.color === 'warning'"
                     [class.clickable]="stage.state === 'completed' && stage.icon && (stage.icon === 'pi-check' || stage.icon === 'pi-times' || stage.icon === 'pi-ban')"
                     (click)="stage.state === 'completed' && stage.icon === 'pi-ban' ? showCancelledDialog() : (stage.state === 'completed' && (stage.icon === 'pi-check' || stage.icon === 'pi-times') && showResultDialog())">
                    @if (stage.icon) {
                        <i class="pi" [ngClass]="stage.icon"></i>
                    }
                </div>
            }
        </div>
        <div class="timeline-labels">
            @for (label of textLabels(); track $index; let isLast = $last) {
                <div class="stage-content">
                    <div class="stage-label" 
                         [class.completed]="label.state === 'completed'"
                         [class.active]="label.state === 'active'"
                         [class.pending]="label.state === 'pending'">
                        {{ label.label }}
                    </div>
                    <div class="stage-details text-muted">{{ label.details }}</div>
                </div>
                @if (!isLast) {
                    <div class="stage-spacer"></div>
                }
            }
        </div>
    </div>

    @if (canCancelAction()) {
        <div class="action-controls">
            <button pButton type="button" 
                    [disabled]="cancelling()"
                    class="p-button-text p-button-sm p-button-danger" 
                    (click)="cancelAction()"><i [class]="cancelling() ? 'pi pi-spin pi-spinner' : 'pi pi-times'" class="p-button-icon" aria-hidden="true"></i><span class="p-button-label">{{ cancelling() ? 'Cancelling...' : 'Cancel Action' }}</span></button>
        </div>
    }

    @if (action().payload) {
        <div class="action-payload">
            <details>
                <summary class="payload-toggle text-muted">
                    <i class="pi pi-code"></i>
                    <span>View payload</span>
                </summary>
                <pre class="payload-content">{{ formatPayload(action()) }}</pre>
            </details>
        </div>
    }
</div>

<p-dialog 
    [(visible)]="showDialog" 
    [modal]="true" 
    [style]="{width: '500px'}"
    [header]="action().status === 'Failed' ? 'Action Failed' : action().status === 'Cancelled' ? 'Action Cancelled' : 'Action Result'">
    <div class="result-dialog-content">
        @if (action().status === 'Failed' && action().resultError) {
            <div class="result-dialog-message error">
                <i class="pi pi-exclamation-circle"></i>
                <div>
                    <h4>Error</h4>
                    <p>{{ action().resultError }}</p>
                </div>
            </div>
        }
        @if (action().status === 'Succeeded' && action().resultMessage) {
            <div class="result-dialog-message success">
                <i class="pi pi-check-circle"></i>
                <div>
                    <h4>Success</h4>
                    <p>{{ action().resultMessage }}</p>
                </div>
            </div>
        }
        @if (action().status === 'Cancelled') {
            <div class="result-dialog-message warning">
                <i class="pi pi-ban"></i>
                <div>
                    <h4>Cancelled</h4>
                    <p>{{ action().resultMessage || 'This action was cancelled.' }}</p>
                </div>
            </div>
        }
        @if (action().completedUtc) {
            <div class="result-dialog-info">
                <span class="info-label">Completed:</span>
                <span class="info-value">{{ formatDate(action().completedUtc) }}</span>
            </div>
        }
    </div>
</p-dialog>
